import { TextField, Box, CardContent, Autocomplete } from "@mui/material";
import React from "react";
import { Card, Grid, Typography } from "../style";
import { DatePicker } from "@mui/x-date-pickers";
import {
  personaFisicaClienteFields,
  personaGiuridicaClienteFields,
  personaGiuridicaLegaleFields,
} from "../../rcAutoDetails2/constants";
import dayjs from "dayjs";
import { formatDate } from "./Veicolo";
import { parseDate } from "../../rcAutoDetails2/helpers";
import { useFormRCAutoDetails } from "../rcautoContext";
import Contatti from "../lib/Contatti";

const Cliente = ({
  cliente,
  legale,
  ed,
  disabledFieldsCliente,
  disabledFieldsLegale,
  isSaved,
  lookupData,
  lookupActions,
}) => {
  const { formState, dispatch } = useFormRCAutoDetails();
  const isPersonaGiuridica = !!legale;

  const {
    nazioni,
    provincie,
    toponomie,
    datiComuniLegale,
    datiCapLegale,
    datiComuniNascitaLegale,
    datiComuniCliente,
    datiComuniNascitaCliente,
    datiCapCliente,
    contatti,
  } = lookupData;

  const {
    setDatiComuniCliente,
    setDatiCapCliente,
    setDatiComuniNascitaCliente,
    setDatiComuniLegale,
    setDatiCapLegale,
    setDatiComuniNascitaLegale,
    updateComune,
    updateCap,
  } = lookupActions;

  const nascitaStatoEsteroCliente = cliente.nascitaStatoEstero;

  const getSelectOptionsForCliente = (field) => {
    const provinciaFieldNames = ["slResProvincia", "nascitaProvincia"];
    if (provinciaFieldNames.includes(field.name)) {
      return provincie;
    }

    if (field.name === "nascitaNazione") {
      return nazioni;
    }

    if (field.name === "nascitaComuneCodice") {
      return datiComuniNascitaCliente;
    }

    if (field.name === "slResComuneCodice") {
      return datiComuniCliente;
    }

    if (field.name === "slResCap") {
      return datiCapCliente;
    }

    if (field.name === "slResIndirizzoVia") {
      return toponomie;
    }

    return [];
  };

  const getSelectOptionsForLegale = (field) => {
    const provinciaFieldNames = ["slResProvincia", "nascitaProvincia"];

    if (provinciaFieldNames.includes(field.name)) {
      return provincie;
    }

    if (field.name === "nascitaNazione") {
      return nazioni;
    }

    if (field.name === "slResComuneCodice") {
      return datiComuniLegale;
    }

    if (field.name === "nascitaComuneCodice") {
      return datiComuniNascitaLegale;
    }

    if (field.name === "slResCap") {
      return datiCapLegale;
    }

    if (field.name === "slResIndirizzoVia") {
      return toponomie;
    }

    return [];
  };

  const handleClienteChange = (name, value) => {
    const fieldDef = (
      isPersonaGiuridica ? personaGiuridicaClienteFields : visibleFields
    ).find((f) => f.name === name);
    const newErrors = { ...formState.errors.Cliente };
    if (name === "nascitaProvincia") {
      setDatiComuniNascitaCliente([]);
      updateComune(value, setDatiComuniNascitaCliente);
      dispatch({
        type: "UPDATE_CLIENTE",
        payload: { nascitaProvincia: value, nascitaComuneCodice: "" },
      });
      newErrors["nascitaComuneCodice"] = "Campo obbligatorio";
    } else if (name === "nascitaComuneCodice") {
      const comune = datiComuniNascitaCliente.find(
        (obj) => obj.value === value,
      );
      dispatch({
        type: "UPDATE_CLIENTE",
        payload: { nascitaComuneCodice: comune ? comune.value : "" },
      });
    } else if (name === "slResProvincia") {
      setDatiComuniCliente([]);
      setDatiCapCliente([]);
      updateComune(value, setDatiComuniCliente);
      dispatch({
        type: "UPDATE_CLIENTE",
        payload: {
          slResProvincia: value,
          slResComuneCodice: "",
          slResCap: "",
        },
      });
      newErrors["slResComuneCodice"] = "Campo obbligatorio";
      newErrors["slResCap"] = "Campo obbligatorio";
    } else if (name === "slResComuneCodice") {
      setDatiCapCliente([]);
      // Clear CAP immediately to avoid "invalid" flash while loading new CAPs
      dispatch({
        type: "UPDATE_CLIENTE",
        payload: {
          slResComuneCodice: value,
          slResCap: "",
        },
      });
      updateCap(value, (capOptions) => {
        setDatiCapCliente(capOptions);
        const comune = datiComuniCliente.find((obj) => obj.value === value);
        dispatch({
          type: "UPDATE_CLIENTE",
          payload: {
            slResComuneCodice: comune ? comune.value : "",
            slResCap: capOptions.length === 1 ? capOptions[0].value : "",
          },
        });
        if (capOptions.length === 1) {
          delete newErrors["slResCap"];
        } else {
          newErrors["slResCap"] = "Campo obbligatorio";
        }
      });
    } else if (name === "dataNascita" || name === "dataFondazione") {
      let date = formatDate(value);
      dispatch({
        type: "UPDATE_CLIENTE",
        payload: {
          [name]: date,
        },
      });
    } else {
      dispatch({
        type: "UPDATE_CLIENTE",
        payload: { [name]: value },
      });
    }

    if (fieldDef?.required && (!value || value === "")) {
      newErrors[name] = "Campo obbligatorio";
    } else {
      delete newErrors[name];
    }
    // aggiorno errori nel global state
    dispatch({
      type: "set_errors",
      scope: "Cliente",
      payload: newErrors,
    });
  };

  const handleLegaleChange = (name, value) => {
    const fieldDef = personaGiuridicaLegaleFields.find((f) => f.name === name);
    const newErrors = { ...formState.errors.Legale };

    if (name === "nascitaProvincia") {
      setDatiComuniNascitaLegale([]);
      updateComune(value, setDatiComuniNascitaLegale);
      dispatch({
        type: "UPDATE_LEGALE",
        payload: { nascitaProvincia: value, nascitaComuneCodice: "" },
      });
      newErrors["nascitaComuneCodice"] = "Campo obbligatorio";
    } else if (name === "nascitaComuneCodice") {
      const comune = datiComuniNascitaLegale.find((obj) => obj.value === value);
      dispatch({
        type: "UPDATE_LEGALE",
        payload: { nascitaComuneCodice: comune ? comune.value : "" },
      });
    } else if (name === "slResProvincia") {
      setDatiComuniLegale([]);
      setDatiCapLegale([]);
      updateComune(value, setDatiComuniLegale);
      dispatch({
        type: "UPDATE_LEGALE",
        payload: {
          slResProvincia: value,
          slResComuneCodice: "",
          slResCap: "",
        },
      });
      newErrors["slResComuneCodice"] = "Campo obbligatorio";
      newErrors["slResCap"] = "Campo obbligatorio";
    } else if (name === "slResComuneCodice") {
      setDatiCapLegale([]);
      // Clear CAP immediately to avoid "invalid" flash while loading new CAPs
      dispatch({
        type: "UPDATE_LEGALE",
        payload: {
          slResComuneCodice: value,
          slResCap: "",
        },
      });
      updateCap(value, (capOptions) => {
        setDatiCapLegale(capOptions);
        const comune = datiComuniLegale.find((obj) => obj.value === value);
        dispatch({
          type: "UPDATE_LEGALE",
          payload: {
            slResComuneCodice: comune ? comune.value : "",
            slResCap: capOptions.length === 1 ? capOptions[0].value : "",
          },
        });
        if (capOptions.length === 1) {
          delete newErrors["slResCap"];
        } else {
          newErrors["slResCap"] = "Campo obbligatorio";
        }
      });
    } else if (name === "dataNascita" || name === "dataFondazione") {
      let date = formatDate(value);
      dispatch({
        type: "UPDATE_LEGALE",
        payload: {
          [name]: date,
        },
      });
    } else {
      dispatch({
        type: "UPDATE_LEGALE",
        payload: { [name]: value },
      });
    }

    if (fieldDef?.required && (!value || value === "")) {
      newErrors[name] = "Campo obbligatorio";
    } else {
      delete newErrors[name];
    }

    // aggiorno errori nel global state
    dispatch({
      type: "set_errors",
      scope: "Legale",
      payload: newErrors,
    });
  };

  // Returns whether a cliente field should be disabled based on ed, isSaved, and initial value
  const getClienteFieldDisabled = (field) => {
    if (field === "piva" || field === "cf") {
      if (disabledFieldsCliente.includes(field)) {
        return true; // was not empty at mount, so always disabled
      }
    }
    if (ed === 1) return false;
    if (
      ed === 2 &&
      isSaved &&
      ![
        "slResIndirizzoVia",
        "slResIndirizzo",
        "slResCap",
        "slResCivico",
      ].includes(field) //Disabled fields if there are not
    ) {
      return true;
    }
    // In edit mode 2, before save:
    // Only fields that were not empty at mount are disabled; fields that were empty at mount are editable until save
    if (ed === 2) {
      if (field === "slResIndirizzoVia") return false;
      if (field === "slResIndirizzo") return false;
      if (field === "slResCap") return false;
      if (field === "slResCivico") return false;

      if (!disabledFieldsCliente.includes(field)) {
        return false; // editable until save
      } else {
        return true; // was not empty at mount, so always disabled
      }
    }
  };

  // Returns whether a legale field should be disabled based on ed, isSaved, and initial value
  const getLegaleFieldDisabled = (field) => {
    if (field === "cf") {
      if (disabledFieldsLegale.includes(field)) {
        return true; // was not empty at mount, so always disabled
      }
    }
    if (ed === 1) return false;
    if (ed === 2 && isSaved) return true;
    if (ed === 2) {
      if (!disabledFieldsLegale.includes(field)) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  //Label stato estero e valore vuoto in comuni quando stato estero === 1
  const visibleFields = !legale
    ? personaFisicaClienteFields.filter((field) => {
        if (
          field.name === "nascitaNazione" &&
          nascitaStatoEsteroCliente !== 1
        ) {
          return false;
        }
        if (
          field.name === "nascitaProvincia" &&
          nascitaStatoEsteroCliente === 1
        ) {
          return false;
        }
        return true;
      })
    : personaGiuridicaLegaleFields.filter((field) => {
        if (
          field.name === "nascitaNazione" &&
          nascitaStatoEsteroCliente !== 1
        ) {
          return false;
        }
        if (
          field.name === "nascitaProvincia" &&
          nascitaStatoEsteroCliente === 1
        ) {
          return false;
        }
        return true;
      });

  console.log(formState);

  return (
    <Box sx={{ width: "100%" }}>
      <Card mb={4}>
        <CardContent>
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {/* Cliente Section */}
            <Grid item xs={12}>
              <Typography my={4} variant="h6">
                Cliente
              </Typography>
            </Grid>

            {(isPersonaGiuridica
              ? personaGiuridicaClienteFields
              : visibleFields
            ).map((field) => {
              let rawValue;

              if (field.name === "slResIndirizzoVia") {
                rawValue = formState.cliente[field.name]?.toUpperCase();
              } else {
                rawValue = formState.cliente[field.name];
              }
              // Determina il valore corretto
              let selectValue = rawValue ?? "";
              // Recupera le options
              let options = getSelectOptionsForCliente(field);
              if (
                nascitaStatoEsteroCliente === 1 &&
                field.name === "nascitaComuneCodice"
              ) {
                options = [{ label: "STATO ESTERO", value: "stato_estero" }];
                selectValue = "stato_estero"; // selezionato automaticamente
              }

              // Se il valore corrente non è tra le opzioni, resetta a ""
              const optionValues =
                options?.map((opt) =>
                  opt && typeof opt === "object"
                    ? String(opt.value)
                    : String(opt),
                ) || [];
              const isInvalid =
                selectValue &&
                selectValue !== "" &&
                !optionValues.includes(String(selectValue));

              if (isInvalid) {
                selectValue = "";
              }
              const isDisabled = getClienteFieldDisabled(field.name);
              return (
                <React.Fragment key={field.name}>
                  {/* Insert a section heading before the residence fields (Provincia/Comune/CAP/Via/Indirizzo/Civico) */}
                  {field.name === "slResProvincia" && (
                    <Grid item xs={12}>
                      <Typography my={4} variant="h6">
                        {!legale ? "Residenza" : "Sede Legale"}
                      </Typography>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={4}>
                    {field.type === "text" && (
                      <TextField
                        label={field.label}
                        name={field.name}
                        value={formState.cliente[field.name] || ""}
                        onChange={(e) =>
                          handleClienteChange(field.name, e.target.value)
                        }
                        fullWidth
                        required={field.required}
                        disabled={isDisabled}
                        error={
                          Boolean(formState.errors.Cliente?.[field.name]) ||
                          (formState.isModificaMode &&
                            [
                              "slResIndirizzo",
                              "slResCap",
                              "slResIndirizzoVia",
                              "slResCivico",
                            ].includes(field.name) &&
                            !formState.cliente[field.name])
                        }
                        helperText={
                          formState.errors.Cliente?.[field.name] ?? ""
                        }
                      />
                    )}
                    {field.type === "select" && (
                      <Autocomplete
                        size="small"
                        fullWidth
                        options={options || []}
                        disabled={isDisabled}
                        getOptionLabel={(option) =>
                          typeof option === "object"
                            ? option.label || ""
                            : String(option)
                        }
                        isOptionEqualToValue={(option, value) => {
                          const optVal =
                            typeof option === "object" ? option.value : option;
                          const valVal =
                            typeof value === "object" ? value.value : value;
                          return String(optVal) === String(valVal);
                        }}
                        value={
                          options?.find(
                            (opt) =>
                              String(opt?.value || opt) === String(selectValue),
                          ) || null
                        }
                        onChange={(_, newValue) => {
                          if (
                            nascitaStatoEsteroCliente === 1 &&
                            field.name === "nascitaComuneCodice"
                          ) {
                            return;
                          }
                          const val =
                            newValue && typeof newValue === "object"
                              ? newValue.value
                              : newValue || "";
                          handleClienteChange(field.name, val);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={field.label}
                            required={field.required}
                            error={
                              nascitaStatoEsteroCliente === 1 &&
                              field.name === "nascitaComuneCodice"
                                ? false
                                : Boolean(
                                    formState.errors.Cliente?.[field.name],
                                  ) ||
                                  isInvalid ||
                                  (formState.isModificaMode &&
                                    [
                                      "slResIndirizzo",
                                      "slResCap",
                                      "slResIndirizzoVia",
                                      "slResCivico",
                                    ].includes(field.name) &&
                                    !selectValue)
                            }
                            helperText={
                              nascitaStatoEsteroCliente === 1 &&
                              field.name === "nascitaComuneCodice"
                                ? ""
                                : formState.errors.Cliente?.[field.name] ||
                                  (isInvalid ? "Campo obbligatorio" : "")
                            }
                          />
                        )}
                      />
                    )}

                    {field.type === "date" && (
                      <DatePicker
                        label={field.label}
                        value={
                          formState.cliente[field.name]
                            ? dayjs(parseDate(formState.cliente[field.name]))
                            : null
                        }
                        onChange={(date) =>
                          handleClienteChange(field.name, date)
                        }
                        InputAdornmentProps={{
                          style: { display: isDisabled ? "none" : "visible" },
                        }}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            required={field.required}
                            disabled={isDisabled}
                            inputProps={{
                              ...params.inputProps,
                              readOnly: isDisabled,
                            }}
                            error={Boolean(
                              formState.errors.Cliente?.[field.name],
                            )}
                            helperText={
                              formState.errors.Cliente?.[field.name] ?? ""
                            }
                          />
                        )}
                        disableFuture
                        openTo="year"
                        views={["year", "month", "day"]}
                      />
                    )}
                  </Grid>
                </React.Fragment>
              );
            })}

            <Contatti contatti={contatti} />
          </Grid>
        </CardContent>
      </Card>
      {isPersonaGiuridica && (
        <Card mb={4}>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography my={4} variant="h6">
                  Legale
                </Typography>
              </Grid>
              {visibleFields.map((field) => {
                const isDisabled = getLegaleFieldDisabled(field.name);

                let rawValue;

                if (field.name === "slResIndirizzoVia") {
                  rawValue = formState.legale[field.name]?.toUpperCase();
                } else {
                  rawValue = formState.legale[field.name];
                }
                // Determina il valore corretto
                let selectValue = rawValue ?? "";

                // Recupera le options
                let options = getSelectOptionsForLegale(field);

                // Se il valore corrente non è tra le opzioni, resetta a ""
                const optionValues =
                  options?.map((opt) =>
                    opt && typeof opt === "object"
                      ? String(opt.value)
                      : String(opt),
                  ) || [];
                const isInvalid =
                  selectValue &&
                  selectValue !== "" &&
                  !optionValues.includes(String(selectValue));

                if (isInvalid) {
                  selectValue = "";
                }

                return (
                  <React.Fragment key={field.name}>
                    {field.name === "slResProvincia" && (
                      <Grid item xs={12}>
                        <Typography my={4} variant="h6">
                          Residenza
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={4}>
                      {field.type === "text" && (
                        <TextField
                          label={field.label}
                          name={field.name}
                          value={formState.legale[field.name] || ""}
                          onChange={(e) =>
                            handleLegaleChange(field.name, e.target.value)
                          }
                          fullWidth
                          required={field.required}
                          disabled={isDisabled}
                          error={Boolean(formState.errors.Legale?.[field.name])}
                          helperText={
                            formState.errors.Legale?.[field.name] ?? ""
                          }
                        />
                      )}

                      {field.type === "select" && (
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={options || []}
                          disabled={isDisabled}
                          getOptionLabel={(option) =>
                            typeof option === "object"
                              ? option.label || ""
                              : String(option)
                          }
                          isOptionEqualToValue={(option, value) => {
                            const optVal =
                              typeof option === "object"
                                ? option.value
                                : option;
                            const valVal =
                              typeof value === "object" ? value.value : value;
                            return String(optVal) === String(valVal);
                          }}
                          value={
                            options?.find(
                              (opt) =>
                                String(opt?.value || opt) ===
                                String(selectValue),
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            const val =
                              newValue && typeof newValue === "object"
                                ? newValue.value
                                : newValue || "";
                            handleLegaleChange(field.name, val);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              required={field.required}
                              error={
                                Boolean(
                                  formState.errors.Legale?.[field.name],
                                ) || isInvalid
                              }
                              helperText={
                                formState.errors.Legale?.[field.name] ||
                                (isInvalid ? "Campo obbligatorio" : "")
                              }
                            />
                          )}
                        />
                      )}

                      {field.type === "date" && (
                        <DatePicker
                          label={field.label}
                          value={
                            formState.legale[field.name]
                              ? dayjs(parseDate(formState.legale[field.name]))
                              : null
                          }
                          onChange={(date) =>
                            handleLegaleChange(field.name, date)
                          }
                          InputAdornmentProps={{
                            style: { display: isDisabled ? "none" : "visible" },
                          }}
                          inputFormat="dd/MM/yyyy"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              required={field.required}
                              disabled={isDisabled}
                              error={Boolean(
                                formState.errors.Legale?.[field.name],
                              )}
                              helperText={
                                formState.errors.Legale?.[field.name] ?? ""
                              }
                              inputProps={{
                                ...params.inputProps,
                                readOnly: isDisabled,
                              }}
                            />
                          )}
                          disableFuture
                          openTo="year"
                          views={["year", "month", "day"]}
                        />
                      )}
                    </Grid>
                  </React.Fragment>
                );
              })}
              <Contatti contatti={contatti} legale />
            </Grid>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default Cliente;
